module.exports = __webpack_public_path__ + "static/img/2.6.da8d901.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/default/upload/picture/2.6.jpg
// module id = jTYc
// module chunks = 7